module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/33592a76d0d0fdaa4a32b2ea41db5e16.svg";